<template>
    <div>
        <button type="button" @click="openSlideOver">
            <slot></slot>
        </button>

        <SlideOver :show="open" @close="open = false">
            <div class="mt-3 flex justify-between">
                <h2 class="text-lg leading-6 font-medium text-gray-900 mb-3">
                    {{ $tc('messages.groups', 2) }}
                </h2>
            </div>

            <div>
                <form :action="session.links.groups.store" @submit.prevent="submit">
                    <div v-for="(group, index) in form.groups" class="mt-3" :key="group.id">
                        <FormLabel :value="group.name" for="date">
                            <span v-if="!group.date">
                                <button @click="setDateToToday(group)" class="text-xs text-indigo-400">
                                    {{ $t('messages.today?') }}
                                </button>
                            </span>
                        </FormLabel>
                        <FormInput
                            id="date_of_session"
                            v-model="group.date"
                            name="date"
                            type="date"
                            class="mt-1 w-full"
                        />
                        <FormError :value="form.errors[`groups.${index}.date`]" class="mt-2" />
                    </div>

                    <AppButton desired-action element="button" type="submit" :disabled="form.processing" class="mt-3">
                        {{ $t('messages.save') }}
                        <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                    </AppButton>
                </form>
            </div>
        </SlideOver>
    </div>
</template>
<script>
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import FormError from '@/components/Forms/FormError.vue';
import AppButton from '@/components/AppButton.vue';
import SlideOver from '@/components/SlideOver.vue';

export default {
    name: 'AddSessionGroupsForm',
    components: {
        SlideOver,
        FormInput,
        FormLabel,
        FormError,
        AppButton,
    },
    emits: ['programmingUpdated'],
    props: {
        session: {
            required: true,
        },
    },
    data() {
        return {
            open: false,
            state: 'loading',
            groups: this.session.groups,
            form: this.$inertia.form({
                groups: this.session.groups,
            }),
        };
    },
    methods: {
        openSlideOver() {
            this.open = true;
        },
        setDateToToday(group) {
            group.date = new Date().toISOString().slice(0, 10);
        },
        submit() {
            this.form.post(this.session.links.groups.store, {
                onSuccess: () => {
                    this.open = false;
                    this.$emit('programmingUpdated');
                },
                preserveScroll: true,
            });
        },
    },
};
</script>
